import { render, staticRenderFns } from "./CustomResultStatusPopup.vue?vue&type=template&id=0d0df0c6&scoped=true&"
import script from "./CustomResultStatusPopup.vue?vue&type=script&lang=js&"
export * from "./CustomResultStatusPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0df0c6",
  null
  
)

export default component.exports